import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import MainLayout from "../components/layout/MainLayout";
import Breadcrumbs from "../components/common/Breadcrumbs";
import SafetyPlanUrduList from "./Residential/Optional/SafetyPlanUrdu/SafetyPlanUrduList";

import {
    fetchSafetyPlansUrdu,
    deleteSafetyPlanUrdu,
    setCurrentSafetyPlanUrdu,
    clearCurrentSafetyPlanUrdu,
    clearErrorUrdu
} from "../store/slices/safetyPlansUrduSlice"; // adjust path if needed

const SafetyPlansUrdu = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { safetyPlansUrdu, currentSafetyPlanUrdu, isLoading, error } = useSelector(
        (state) => state.safetyPlansUrdu
    );

    useEffect(() => {
        dispatch(fetchSafetyPlansUrdu());
        return () => {
            dispatch(clearCurrentSafetyPlanUrdu());
            dispatch(clearErrorUrdu());
        };
    }, [dispatch]);

    const handleAdd = () => navigate("/residential/optional/safety-plan-urdu/add");
    const handleEdit = (id) => navigate(`/residential/optional/safety-plan-urdu/edit/${id}`);
    const handleDelete = (id) => dispatch(deleteSafetyPlanUrdu(id));

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />
                <div className="card">
                    <h5 className="card-header text-center fw-bold">Safety Plans (Urdu)</h5>
                    <div className="card-body p-0">
                        <SafetyPlanUrduList
                            records={safetyPlansUrdu}
                            loading={isLoading}
                            onAdd={handleAdd}
                            onEdit={handleEdit}
                            onDelete={handleDelete}
                        />
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default SafetyPlansUrdu;
